export default "__VITE_ASSET__DyzS2WxP__"